import * as types from "../actions";
const initialState = {
  files: [],
  filesLoading: false,
};

export default function pbhFiles(state = initialState, action) {
  const response = action.payload;
  switch (action.type) {
    case types.PBH_REQUEST_SET_FILES:
      return { ...state, files: response };
    case types.PBH_REQUEST_SET_FILES_LOADING:
      return { ...state, filesLoading: response };
    default:
      return state;
  }
}
